import log from 'loglevel'
import lang from '../util/lang'

export default (state, action) => {
  const { payload } = action
  log.debug(`Widget Action: ${action.type}`, payload ?? 'none')

  switch (action.type) {
    // Initial set up
    case 'USER_AUTHENTICATED':
      return {
        ...state,
        isAuthenticated: !!payload.token,
        credentials: {
          ...state.credentials,
          token: payload.token,
        },
        user: {
          firstName: payload.user.firstName,
          lastName: payload.user.lastName,
          email: payload.user.emailId,
        },
        // Used by Case and Chat
        userSession: {
          first: payload.user.firstName,
          last: payload.user.lastName,
          email: payload.user.emailId,
        },
      }
    case 'SET_UP_LANGUAGE_STRINGS':
      return {
        ...state,
        langStrings: lang[payload],
      }

    case 'TOGGLE_QUESTION_EXTENSION':
      return {
        ...state,
        hasExtension: !state.hasExtension,
      }
    case 'AGENT_LOADED':
      return {
        ...state,
        hasAgentLoaded: true,
      }
    case 'AGENT_AVALIABLE':
      return {
        ...state,
        isAgentAvailable: payload.isAgentAvailable,
      }
    case 'ANALYTICS_SENT':
      return {
        ...state,
        gtmAnalyticsPushed: action.payload.gtmAnalyticsPushed,
      }
    default:
      return state
  }
}
